<template>
  <div :key="dialogKey">
    <el-dialog
      :title="isEdit ? '编辑店铺' : '新增店铺'"
      :visible.sync="visible"
      width="700px"
      :close-on-click-modal="false"
      @closed="handleClosed"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-tabs type="border-card" v-model="activeTab" :before-leave="validateTab">
          <el-tab-pane label="基本信息" name="basic">
            <el-form-item label="店铺名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入店铺名称" />
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入联系电话" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="openMapPicker">地图选点</el-button>
              <span style="margin-left: 10px; color: #999;">点击在地图上选择位置获取坐标</span>
              <span v-if="form.longitude && form.latitude" style="margin-left: 10px; color: #67c23a;">
                ✓ 已获取坐标
              </span>
            </el-form-item>
            <el-form-item label="省份" prop="province">
              <el-select v-model="form.province" placeholder="请选择省份" @change="handleProvinceChange">
                <el-option
                  v-for="item in provinces"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="城市" prop="city">
              <el-select v-model="form.city" placeholder="请选择城市" @change="handleCityChange" :disabled="!form.province">
                <el-option
                  v-for="item in currentCities"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="区/县" prop="district">
              <el-select v-model="form.district" placeholder="请选择区/县" :disabled="!form.city">
                <el-option
                  v-for="item in currentDistricts"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入详细地址" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="工商信息" name="business">
            <el-form-item label="营业执照注册号" prop="businessLicenseNo">
              <el-input v-model="form.businessLicenseNo" placeholder="请输入营业执照注册号" />
            </el-form-item>
            <el-form-item label="营业执照名称" prop="businessLicenseName">
              <el-input v-model="form.businessLicenseName" placeholder="请输入营业执照上的企业名称" />
            </el-form-item>
            <el-form-item label="法人姓名" prop="legalPerson">
              <el-input v-model="form.legalPerson" placeholder="请输入企业法人姓名" />
            </el-form-item>
            <el-form-item label="注册地址" prop="registerAddress">
              <el-input v-model="form.registerAddress" placeholder="请输入注册地址" />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="物流信息" name="logistics">
            <el-form-item label="发货人" prop="shipName">
              <el-input v-model="form.shipName" placeholder="请输入发货人姓名" />
            </el-form-item>
            <el-form-item label="发货电话" prop="shipPhone">
              <el-input v-model="form.shipPhone" placeholder="请输入发货联系电话" />
            </el-form-item>
            <el-form-item label="发货地址" prop="shipAddress">
              <el-input v-model="form.shipAddress" placeholder="请输入发货地址" />
            </el-form-item>
            <el-divider content-position="left">归还地址</el-divider>
            <el-form-item label="归还收货人" prop="returnName">
              <el-input v-model="form.returnName" placeholder="请输入归还收货人姓名" />
            </el-form-item>
            <el-form-item label="归还电话" prop="returnPhone">
              <el-input v-model="form.returnPhone" placeholder="请输入归还联系电话" />
            </el-form-item>
            <el-form-item label="归还地址" prop="returnAddress">
              <el-input v-model="form.returnAddress" placeholder="请输入归还收货地址" />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="e签宝配置" name="esign">
            <el-alert title="配置e签宝电子合同签署参数，用于该商户订单发起合同签约。未填写的配置项将使用系统默认值。" type="info" :closable="false" style="margin-bottom: 16px;" />
            <el-form-item label="印章 ID" prop="esignSealId">
              <el-input v-model="esignForm.sealId" placeholder="商户授权给平台的e签宝企业印章ID（必填）" />
              <div class="form-tip">商户注册e签宝后，将企业印章授权给平台，在印章管理中获取印章ID</div>
            </el-form-item>
            <el-form-item label="App ID" prop="esignAppId">
              <el-input v-model="esignForm.appId" placeholder="e签宝开放平台应用ID（可选，未填使用系统默认）" />
            </el-form-item>
            <el-form-item label="App Secret" prop="esignAppSecret">
              <el-input v-model="esignForm.appSecret" type="password" show-password placeholder="应用密钥（可选，编辑时显示脱敏值）" />
              <div class="form-tip">编辑时显示脱敏值，如需修改请完整填写新密钥</div>
            </el-form-item>
            <el-form-item label="企业 ID" prop="esignOrgId">
              <el-input v-model="esignForm.orgId" placeholder="商户在e签宝的企业ID（可选）" />
            </el-form-item>
            <el-form-item label="合同模板 ID" prop="esignTemplateId">
              <el-input v-model="esignForm.templateId" placeholder="商户自定义合同模板ID（可选，未填使用系统默认）" />
            </el-form-item>
            <el-form-item label="回调地址" prop="esignNotifyUrl">
              <el-input v-model="esignForm.notifyUrl" placeholder="e签宝回调通知地址（可选，未填使用系统默认）" />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="地图选点"
      :visible.sync="mapDialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 10px;">
        <el-input
          v-model="searchAddress"
          placeholder="请输入地址搜索"
          @keyup.enter="handleSearch"
          style="width: 300px; margin-right: 10px;"
        />
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button type="default" @click="handleLocation">定位当前位置</el-button>
      </div>
      <div v-if="searchResults.length > 0" style="margin-bottom: 10px; max-height: 150px; overflow-y: auto; border: 1px solid #e4e7ed; padding: 5px;">
        <div
          v-for="(item, index) in searchResults"
          :key="index"
          @click="selectSearchResult(item)"
          style="padding: 8px; cursor: pointer; hover: #f5f7fa;"
          :class="{ 'el-button--primary': selectedSearchIndex === index }"
        >
          {{ item.name }} - {{ item.address }}
        </div>
      </div>
      <div id="mapContainer" style="height: 400px;"></div>
      <div slot="footer">
        <el-button @click="mapDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmMapSelection">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { provinces } from '@/data/regions'
export default {
  name: 'ShopForm',
  data() {
    return {
      visible: false,
      isEdit: false,
      editingId: null,
      submitting: false,
      mapDialogVisible: false,
      selectedPoint: null,
      dialogKey: 0,
      mapInstance: null,
      searchAddress: '',
      searchResults: [],
      selectedSearchIndex: -1,
      activeTab: 'basic',
      provinces,
      currentCities: [],
      currentDistricts: [],
      esignForm: {
        id: null,
        shopId: null,
        appId: '',
        appSecret: '',
        orgId: '',
        sealId: '',
        templateId: '',
        notifyUrl: ''
      },
      esignLoading: false,
      form: {
        name: '',
        province: '',
        city: '',
        district: '',
        address: '',
        phone: '',
        longitude: '',
        latitude: '',
        businessLicenseNo: '',
        businessLicenseName: '',
        legalPerson: '',
        registerAddress: '',
        shipName: '',
        shipPhone: '',
        shipAddress: '',
        returnName: '',
        returnPhone: '',
        returnAddress: '',
        status: 1
      },
      rules: {
        name: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        businessLicenseNo: [
          { required: true, message: '请输入营业执照注册号', trigger: 'blur' }
        ],
        businessLicenseName: [
          { required: true, message: '请输入营业执照名称', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        registerAddress: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        shipName: [
          { required: true, message: '请输入发货人', trigger: 'blur' }
        ],
        shipPhone: [
          { required: true, message: '请输入发货电话', trigger: 'blur' }
        ],
        shipAddress: [
          { required: true, message: '请输入发货地址', trigger: 'blur' }
        ],
        returnName: [
          { required: true, message: '请输入归还收货人', trigger: 'blur' }
        ],
        returnPhone: [
          { required: true, message: '请输入归还电话', trigger: 'blur' }
        ],
        returnAddress: [
          { required: true, message: '请输入归还地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row = null) {
      this.resetForm()
      if (row) {
        this.isEdit = true
        this.editingId = row.id
        this.form = {
          id: row.id,
          name: row.name || '',
          province: row.province || '',
          city: row.city || '',
          district: row.district || '',
          address: row.address || '',
          phone: row.phone || '',
          longitude: row.longitude || '',
          latitude: row.latitude || '',
          businessLicenseNo: row.businessLicenseNo || '',
          businessLicenseName: row.businessLicenseName || '',
          legalPerson: row.legalPerson || '',
          registerAddress: row.registerAddress || '',
          shipName: row.shipName || '',
          shipPhone: row.shipPhone || '',
          shipAddress: row.shipAddress || '',
          returnName: row.returnName || '',
          returnPhone: row.returnPhone || '',
          returnAddress: row.returnAddress || '',
          status: row.status !== undefined ? row.status : 1
        }
        this.loadCities(row.province)
        if (row.province && row.city) {
          this.loadDistricts(row.city)
        }
        // 加载 e签宝配置
        this.loadEsignConfig(row.id)
      } else {
        this.isEdit = false
        this.editingId = null
      }
      
      this.dialogKey++
      this.$nextTick(() => {
        this.visible = true
      })
    },
    resetForm() {
      this.form = {
        name: '',
        province: '',
        city: '',
        district: '',
        address: '',
        phone: '',
        longitude: '',
        latitude: '',
        businessLicenseNo: '',
        businessLicenseName: '',
        legalPerson: '',
        registerAddress: '',
        shipName: '',
        shipPhone: '',
        shipAddress: '',
        returnName: '',
        returnPhone: '',
        returnAddress: '',
        status: 1
      }
      this.esignForm = {
        id: null,
        shopId: null,
        appId: '',
        appSecret: '',
        orgId: '',
        sealId: '',
        templateId: '',
        notifyUrl: ''
      }
      this.currentCities = []
      this.currentDistricts = []
    },
    handleClosed() {
      this.resetForm()
    },
    handleProvinceChange(val) {
      this.form.city = ''
      this.form.district = ''
      this.loadCities(val)
    },
    handleCityChange(val) {
      this.form.district = ''
      this.loadDistricts(val)
    },
    loadCities(provinceName) {
      const province = this.provinces.find(p => p.name === provinceName)
      if (province && province.cities) {
        this.currentCities = province.cities
      } else {
        this.currentCities = []
      }
    },
    loadDistricts(cityName) {
      const province = this.provinces.find(p => 
        p.cities && p.cities.some(c => c.name === cityName)
      )
      if (province) {
        const city = province.cities.find(c => c.name === cityName)
        if (city && city.districts) {
          this.currentDistricts = city.districts
        } else {
          this.currentDistricts = []
        }
      } else {
        this.currentDistricts = []
      }
    },
    validateTab() {
      return true
    },
    // 加载 e签宝配置
    loadEsignConfig(shopId) {
      this.$axios.get(`/esign-config/shop/${shopId}`).then(res => {
        if (res.data) {
          this.esignForm = {
            id: res.data.id || null,
            shopId: shopId,
            appId: res.data.appId || '',
            appSecret: res.data.appSecret || '',
            orgId: res.data.orgId || '',
            sealId: res.data.sealId || '',
            templateId: res.data.templateId || '',
            notifyUrl: res.data.notifyUrl || ''
          }
        }
      }).catch(() => {
        // 未配置时静默
      })
    },
    // 保存 e签宝配置
    saveEsignConfig(shopId) {
      // 印章 ID 必填
      if (!this.esignForm.sealId) {
        // 如果已有配置记录，不校验（编辑场景）
        if (!this.esignForm.id) {
          return Promise.resolve()
        }
      }
      // 如果印章 ID 为空且已有配置，说明要删除配置（不处理，仅跳过）
      if (!this.esignForm.sealId) {
        return Promise.resolve()
      }
      const payload = {
        shopId,
        appId: this.esignForm.appId || undefined,
        appSecret: this.esignForm.appSecret || undefined,
        orgId: this.esignForm.orgId || undefined,
        sealId: this.esignForm.sealId,
        templateId: this.esignForm.templateId || undefined,
        notifyUrl: this.esignForm.notifyUrl || undefined
      }
      if (this.esignForm.id) {
        return this.$axios.put(`/esign-config/${this.esignForm.id}`, payload)
      } else {
        return this.$axios.post('/esign-config', payload)
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true
          const saveShop = () => {
            const shopPromise = this.isEdit
              ? this.$axios.put(`/shop/${this.editingId}`, this.form)
              : this.$axios.post('/shop', this.form)
            shopPromise.then(res => {
              if (res.code === 200) {
                // 保存 e签宝配置
                const shopId = this.isEdit ? this.editingId : (res.data && res.data.id)
                this.saveEsignConfig(shopId).then(() => {
                  this.$message.success(this.isEdit ? '修改成功' : '新增成功')
                  this.visible = false
                  this.$emit('saved')
                }).catch(() => {
                  this.$message.warning('店铺保存成功，但 e签宝配置保存失败')
                  this.visible = false
                  this.$emit('saved')
                })
              } else {
                this.$message.error(res.message || '操作失败')
              }
            }).catch(() => {
              this.$message.error('操作失败')
            }).finally(() => {
              this.submitting = false
            })
          }
          saveShop()
        }
      })
    },
    openMapPicker() {
      this.mapDialogVisible = true
      this.$nextTick(() => {
        this.initMap()
      })
    },
    initMap() {
      if (window.AMap) {
        this.createMap()
      } else {
        window._AMapSecurityConfig = {
          securityJsCode: '5b85fb342db540bee04a6a11df366141'
        }
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://webapi.amap.com/maps?v=2.0&key=4ad5ed74ad9a2ab4ac8184c200a775fd'
        script.onload = () => {
          this.createMap()
        }
        document.head.appendChild(script)
      }
    },
    createMap() {
      if (this.mapInstance) {
        this.mapInstance.destroy()
      }
      
      this.mapInstance = new window.AMap.Map('mapContainer', {
        zoom: 12,
        center: this.form.longitude && this.form.latitude 
          ? [parseFloat(this.form.longitude), parseFloat(this.form.latitude)]
          : [116.397428, 39.90923]
      })
      
      this.mapInstance.on('click', (e) => {
        this.selectPoint(e.lnglat)
      })
      
      if (this.form.longitude && this.form.latitude) {
        const marker = new window.AMap.Marker({
          position: [parseFloat(this.form.longitude), parseFloat(this.form.latitude)]
        })
        this.mapInstance.add(marker)
        this.selectedPoint = { lng: parseFloat(this.form.longitude), lat: parseFloat(this.form.latitude) }
      }
    },
    selectPoint(lnglat) {
      this.mapInstance.clearMap()
      const marker = new window.AMap.Marker({
        position: lnglat
      })
      this.mapInstance.add(marker)
      this.selectedPoint = { lng: lnglat.lng, lat: lnglat.lat }
    },
    handleSearch() {
      if (!this.searchAddress.trim()) {
        return
      }
      
      window.AMap.plugin('AMap.PlaceSearch', () => {
        const placeSearch = new window.AMap.PlaceSearch({
          pageSize: 10,
          pageIndex: 1
        })
        
        placeSearch.search(this.searchAddress, (status, result) => {
          console.log('Search status:', status)
          console.log('Search result:', result)
          if (status === 'complete' && result.poiList && result.poiList.pois) {
            this.searchResults = result.poiList.pois.map(item => ({
              name: item.name,
              address: item.address,
              lng: item.location.lng,
              lat: item.location.lat
            }))
          } else {
            this.searchResults = []
            this.$message.warning('未找到匹配的地址')
          }
        })
      })
    },
    selectSearchResult(item) {
      this.mapInstance.clearMap()
      const marker = new window.AMap.Marker({
        position: [item.lng, item.lat]
      })
      this.mapInstance.add(marker)
      this.mapInstance.setCenter([item.lng, item.lat])
      this.selectedPoint = { lng: item.lng, lat: item.lat }
      this.searchResults = []
      this.searchAddress = ''
    },
    handleLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const lng = position.coords.longitude
          const lat = position.coords.latitude
          
          this.mapInstance.clearMap()
          const marker = new window.AMap.Marker({
            position: [lng, lat]
          })
          this.mapInstance.add(marker)
          this.mapInstance.setCenter([lng, lat])
          this.selectedPoint = { lng, lat }
        }, () => {
          this.$message.warning('定位失败，请手动选择位置')
        })
      } else {
        this.$message.warning('您的浏览器不支持定位功能')
      }
    },
    confirmMapSelection() {
      if (this.selectedPoint) {
        this.form.longitude = this.selectedPoint.lng.toString()
        this.form.latitude = this.selectedPoint.lat.toString()
        
        this.getAddressInfo(this.selectedPoint)
        
        this.mapDialogVisible = false
      } else {
        this.$message.warning('请先在地图上选择一个位置')
      }
    },
    getAddressInfo(position) {
      window.AMap.plugin('AMap.Geocoder', () => {
        const geocoder = new window.AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        })
        
        geocoder.getAddress(position, (status, result) => {
          console.log('Geocoder result:', status, result)
          if (status === 'complete' && result.regeocode) {
            const addressComponent = result.regeocode.addressComponent
            if (addressComponent) {
              if (addressComponent.province) {
                this.form.province = addressComponent.province
                this.loadCities(addressComponent.province)
                
                this.$nextTick(() => {
                  if (addressComponent.city && addressComponent.city.length > 0) {
                    const cityName = addressComponent.city
                    this.form.city = cityName
                    this.loadDistricts(cityName)
                    
                    this.$nextTick(() => {
                      if (addressComponent.district) {
                        this.form.district = addressComponent.district
                      }
                    })
                  } else if (addressComponent.province) {
                    this.form.city = addressComponent.province
                    this.loadDistricts(addressComponent.province)
                    
                    this.$nextTick(() => {
                      if (addressComponent.district) {
                        this.form.district = addressComponent.district
                      }
                    })
                  }
                })
              }
              
              if (result.regeocode.formattedAddress) {
                this.form.address = result.regeocode.formattedAddress
              }
            }
          }
        })
      })
    }
  }
}
</script>